import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as SupplierCategoryAction from './../../../../actions/supplierCategoryAction';
import SupplierCategory from './SupplierCategory';

const mapStateToProps = state => {
    return {
        supplierCategoryState: state.supplierCategoryReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSupplierCategoryList: (filters) => dispatch(SupplierCategoryAction.getSupplierCategoryList(filters)),
        deleteSupplierCategoryAction: (category, refreshParams) => dispatch(SupplierCategoryAction.deleteSupplierCategoryAction(category, refreshParams)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SupplierCategory));